import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useLocation } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import Input from '../inputs/Input';
import Select from '../inputs/Select';
import Button from '../buttons_refactor/Button';
import useModal from './useModal';
import { slides as services } from '../ServiceCarousel';

const QuoteForm = () => {
  const [selectedServiceValue, setSelectedServiceValue] = React.useState('');
  const { pathname } = useLocation();
  const [, modalDispatch] = useModal();

  React.useLayoutEffect(() => {
    document.querySelector('.flag-dropdown')?.remove();
    // update selected service based on current route
    const currentServiceSlug = pathname.replace('/services/', '');
    const service = services.find(({ slug }) => slug === currentServiceSlug);
    setSelectedServiceValue(service ? service.value : '');
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      company: '',
      email: '',
      phone: '',
      service: selectedServiceValue,
      quoteMessage: '',
    },
    validationSchema: yup.object({
      name: yup.string().required('Required'),
      company: yup.string(),
      email: yup.string().email('Invalid email address').required('Required'),
      phone: yup
        .string()
        .required('Required')
        .length(10, 'phone must be exactly 10 digits'),
      service: yup.string().required('Required'),
      quoteMessage: yup.string().required('Required'),
    }),
    onSubmit: values => {
      console.log(JSON.stringify(values, null, 2));
      alert('Submission successful');
      modalDispatch({ type: 'close' });
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="mb-6">
        <Input
          type="text"
          id="name"
          placeholder="Name"
          onChange={formik.handleChange}
          value={formik.values.name}
          touched={formik.touched.name}
          error={formik.errors.name}
        />
      </div>
      <div className="mb-6">
        <Input
          type="text"
          id="company"
          placeholder="Company (Optional)"
          onChange={formik.handleChange}
          value={formik.values.company}
          touched={formik.touched.company}
          error={formik.errors.company}
        />
      </div>
      <div className="mb-6">
        <Input
          type="email"
          id="email"
          placeholder="Email Address"
          onChange={formik.handleChange}
          value={formik.values.email}
          touched={formik.touched.email}
          error={formik.errors.email}
        />
      </div>
      <div className="mb-6">
        <Input
          tag={PhoneInput}
          type="tel"
          id="phone"
          placeholder="Phone Number"
          onChange={formik.handleChange}
          value={formik.values.phone}
          touched={formik.touched.phone}
          error={formik.errors.phone}
        />
      </div>
      {/* temp */}
      <div className="mb-6">
        <Select
          id="service"
          value={formik.values.service}
          onChange={formik.handleChange}
        >
          <option value="">Select a Service</option>
          <option value="Fire">Fire Alarms</option>
          <option value="Voice Data">Voice & Data</option>
          {/* need to confirm backend data for Paging, Intercom & Clocks */}
          <option value="Telephones">Paging, Intercom & Clocks</option>
          <option value="Security">Security & Serveillance Solutions</option>
          <option value="Audio Video">Audio & Video</option>
          {/* need to confirm backend data for Access Control */}
          <option value="Security">Access Control</option>
          <option value="Telephones">Telephony & Network Engineering</option>
        </Select>
        {formik.touched.service && formik.errors.service ? (
          <div className="absolute font-montserrat font-bold text-xs text-enterpriseOrange-500 px-4.5">
            {formik.errors.service}
          </div>
        ) : null}
      </div>
      <div className="mb-6">
        <textarea
          id="quoteMessage"
          placeholder="Message"
          cols="30"
          rows="10"
          value={formik.values.quoteMessage}
          onChange={formik.handleChange}
          className="bg-white placeholder-gray-400 text-gray-700 border-2 border-techsicoGray-500 hover:border-opacity-80 rounded-2xl text-sm px-4 py-3 w-full font-montserrat font-bold leading-1.55em h-32 lg:text-base lg:h-44 focus:outline-none focus:border-enterpriseOrange-500"
        />
        {formik.touched.quoteMessage && formik.errors.quoteMessage ? (
          <div className="absolute font-montserrat font-bold text-xs text-enterpriseOrange-500 px-4.5">
            {formik.errors.quoteMessage}
          </div>
        ) : null}
      </div>
      <div className="flex flex-row-reverse m-0.5">
        <Button type="submit">Submit Request</Button>
      </div>
    </form>
  );
};

export default QuoteForm;
